var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHrMonintorihng(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3C7.02944 3 3 7.02944 3 12C3 15.1204 4.58803 17.8699 7 19.4845V16.436C7 16.2665 7.10427 16.1215 7.31281 16.001L7.62561 15.8201L10.3724 14.52C10.1509 14.3441 9.96514 14.1323 9.81525 13.8847C9.66536 13.637 9.54317 13.3845 9.44868 13.1271C9.35419 12.8697 9.28739 12.6188 9.24829 12.3744C9.20919 12.13 9.18964 11.9231 9.18964 11.7537V10.1896C9.18964 9.92897 9.2711 9.6683 9.43402 9.40762C9.59694 9.14695 9.81036 8.91235 10.0743 8.70381C10.3382 8.49527 10.6396 8.32584 10.9785 8.1955C11.3174 8.06517 11.6595 8 12.0049 8C12.3503 8 12.6908 8.06517 13.0264 8.1955C13.362 8.32584 13.6618 8.49527 13.9257 8.70381C14.1896 8.91235 14.4047 9.14695 14.5709 9.40762C14.737 9.6683 14.8201 9.92897 14.8201 10.1896V11.7537C14.8201 11.9427 14.8006 12.161 14.7615 12.4086C14.7224 12.6562 14.6572 12.9088 14.566 13.1662C14.4747 13.4236 14.3542 13.6712 14.2043 13.9091C14.0544 14.147 13.8719 14.3506 13.6569 14.52L16.3842 15.8201L16.6921 15.9912C16.8974 16.1052 17 16.2535 17 16.436V19.4845C19.412 17.8699 21 15.1204 21 12C21 7.02944 16.9706 3 12 3Z",
    fill: "#74C36E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHrMonintorihng);
export default __webpack_public_path__ + "static/media/hr-monintorihng.add89950a87a91ffaf276bf7990fa8e8.svg";
export { ForwardRef as ReactComponent };